
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexuzsgFj9OKkUF06flNXjnqNqC8GsA4MtSyO89qmwHnrUMeta } from "/app/pages/new/index.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as indexgXAvaMPwKrurPyfrnchlOoI4Og1SV7Q_45uxSxTgQKpqEMeta } from "/app/pages/cart/index.vue?macro=true";
import { default as indexAEGpiNScNpSbDWUinDcM5EVeUkytR9T_DUB_QCEjVxkMeta } from "/app/pages/sale/index.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_45fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as maintenanceT_45jg7_pWb39JSa1hwfoRit1d5KL66Qjib5lqwfdmyV8Meta } from "/app/pages/maintenance.vue?macro=true";
import { default as index2PYMTDJrpLuKw87XcSdwT4b4Wne8Fi8XVnZfQYbjf_AMeta } from "/app/pages/brands/index.vue?macro=true";
import { default as indexjzm98OL8ih7w8l4vG452J1aM4s0mZ0vcSJmfFydywsUMeta } from "/app/pages/search/index.vue?macro=true";
import { default as _91name_936Xbbt9vpd1j5beahfpZp4oKq2IAe94qsAXhqi20IXLEMeta } from "/app/pages/brands/[name].vue?macro=true";
import { default as indexF1_dP0HECEkwEGBm1Z_45T81DlZYXsU7etJSP2_45qEb5OEMeta } from "/app/pages/catalog/index.vue?macro=true";
import { default as info0vDV69Pfk_45pXP86y2F2_45cTix70Eo5h0pVdjF5yBzhTcMeta } from "/app/pages/profile/index/info.vue?macro=true";
import { default as addressZU57Az6SGe7cJ_45he3CzPPZbgi4dZgNF8T1VDt8RjkFYMeta } from "/app/pages/profile/index/address.vue?macro=true";
import { default as loyaltyZieIKRkU8ovceyf_45hsrM5WV1PsOu2RHm_45Tv23jOAEzgMeta } from "/app/pages/profile/index/loyalty.vue?macro=true";
import { default as feedback_yP8UwLCtSK2Zab933XbI3rpMXeziHRiBuJcBG3jvGoMeta } from "/app/pages/profile/index/feedback.vue?macro=true";
import { default as promo_45codesWDEcJJADCpypnftiovabt2cB33NyZpd672DTv5YQ_45NIMeta } from "/app/pages/profile/index/promo-codes.vue?macro=true";
import { default as indexr_45bd_45qF_453Y7ZPAtC9YCOhBhHqlWa5_45_45kL7nq15FXXT8Meta } from "/app/pages/profile/index/orders/index.vue?macro=true";
import { default as notificationsycEYlm2HG2DZ3tGeWcc2fQ69ruvriBGdwJGAz9uCNbkMeta } from "/app/pages/profile/index/notifications.vue?macro=true";
import { default as _91orderId_93K2qxfJlh9pWk7GFOn_8lAnRipHWCep5Wps_jZv_457Mv4Meta } from "/app/pages/profile/index/orders/[orderId].vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as indexSaxHqzkOpPV3NiTjBnLewEHU_455pvtU_45KGy6FLf8X31UMeta } from "/app/pages/sitemap/index.vue?macro=true";
import { default as index7PHmsvhFvB_g5kZxgiuxoeT0bdw2nPdkEwlj4tb_456q4Meta } from "/app/pages/checkout/index.vue?macro=true";
import { default as _91_46_46_46slug_93cBfOXaf_459dnkHFpZ7FQyv60NSarCREP3bQtUjkT3eBMMeta } from "/app/pages/info/[...slug].vue?macro=true";
import { default as sending67ptIXJggewszh438jaXCK7CHrOaSBP_k0LdoOQccrMMeta } from "/app/pages/orders/sending.vue?macro=true";
import { default as page_45not_45foundoeY2IBss3_N5Lc7_45HQZxxhvj6tMS_45LnrVWV_45fuFKcJ0Meta } from "/app/pages/page-not-found.vue?macro=true";
import { default as indexXm4XUwG3woA6iQvDw_RWZ0USfbEp6cAFX7Ziu_H5woYMeta } from "/app/pages/favorites/index.vue?macro=true";
import { default as _91orderUri_935X1xZ1lrcFNs892X3djsQ84ZdqAOpGztil8tREDgBkMMeta } from "/app/pages/orders/[orderUri].vue?macro=true";
import { default as indexlgcJB0hIPkcd4IvceHzbmRC98Fzl2Z_dQQL_45sjT2b6wMeta } from "/app/pages/sale/[...slug]/index.vue?macro=true";
import { default as indexF9g60NXpcCbwPj1K_I578p7HWjHZoFikgBT7vL3xpNAMeta } from "/app/pages/special-offers/index.vue?macro=true";
import { default as _91slug_93KiERUUND9t4cK12tCvXao3xiwKrXxeu2Qnc2ty03sTQMeta } from "/app/pages/special-offers/[slug].vue?macro=true";
import { default as archiveXwhoTSCRF8jJe8XuTVzogvq8gvbBnlyw0U9LS_45LsJl8Meta } from "/app/pages/special-offers/archive.vue?macro=true";
import { default as indexXjqR5V9VJcsPV7sZpVwaYOHYZz7XaPhw2M_451C4O9aNgMeta } from "/app/pages/catalog/[...slug]/index.vue?macro=true";
import { default as _91orderId_93CObKM3Nl__Bs7uB_2ypD0KOfkvDxu_vJx6mlI5kQ5pUMeta } from "/app/pages/orders/confirmation/[orderId].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "new",
    path: "/new",
    component: () => import("/app/pages/new/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: indexgXAvaMPwKrurPyfrnchlOoI4Og1SV7Q_45uxSxTgQKpqEMeta || {},
    component: () => import("/app/pages/cart/index.vue")
  },
  {
    name: "sale",
    path: "/sale",
    component: () => import("/app/pages/sale/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceT_45jg7_pWb39JSa1hwfoRit1d5KL66Qjib5lqwfdmyV8Meta || {},
    component: () => import("/app/pages/maintenance.vue")
  },
  {
    name: "brands",
    path: "/brands",
    meta: index2PYMTDJrpLuKw87XcSdwT4b4Wne8Fi8XVnZfQYbjf_AMeta || {},
    component: () => import("/app/pages/brands/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexjzm98OL8ih7w8l4vG452J1aM4s0mZ0vcSJmfFydywsUMeta || {},
    component: () => import("/app/pages/search/index.vue")
  },
  {
    name: "brands-name",
    path: "/brands/:name()",
    component: () => import("/app/pages/brands/[name].vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    meta: indexF1_dP0HECEkwEGBm1Z_45T81DlZYXsU7etJSP2_45qEb5OEMeta || {},
    component: () => import("/app/pages/catalog/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile/index.vue"),
    children: [
  {
    name: "profile-index-info",
    path: "info",
    component: () => import("/app/pages/profile/index/info.vue")
  },
  {
    name: "profile-index-address",
    path: "address",
    component: () => import("/app/pages/profile/index/address.vue")
  },
  {
    name: "profile-index-loyalty",
    path: "loyalty",
    component: () => import("/app/pages/profile/index/loyalty.vue")
  },
  {
    name: "profile-index-feedback",
    path: "feedback",
    component: () => import("/app/pages/profile/index/feedback.vue")
  },
  {
    name: "profile-index-promo-codes",
    path: "promo-codes",
    component: () => import("/app/pages/profile/index/promo-codes.vue")
  },
  {
    name: "profile-index-orders",
    path: "orders",
    component: () => import("/app/pages/profile/index/orders/index.vue")
  },
  {
    name: "profile-index-notifications",
    path: "notifications",
    component: () => import("/app/pages/profile/index/notifications.vue")
  },
  {
    name: "profile-index-orders-orderId",
    path: "orders/:orderId()",
    component: () => import("/app/pages/profile/index/orders/[orderId].vue")
  }
]
  },
  {
    name: "sitemap",
    path: "/sitemap",
    meta: indexSaxHqzkOpPV3NiTjBnLewEHU_455pvtU_45KGy6FLf8X31UMeta || {},
    component: () => import("/app/pages/sitemap/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/app/pages/checkout/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug(.*)*",
    component: () => import("/app/pages/info/[...slug].vue")
  },
  {
    name: "orders-sending",
    path: "/orders/sending",
    component: () => import("/app/pages/orders/sending.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    component: () => import("/app/pages/page-not-found.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/app/pages/favorites/index.vue")
  },
  {
    name: "orders-orderUri",
    path: "/orders/:orderUri()",
    component: () => import("/app/pages/orders/[orderUri].vue")
  },
  {
    name: "sale-slug",
    path: "/sale/:slug(.*)*",
    component: () => import("/app/pages/sale/[...slug]/index.vue")
  },
  {
    name: "special-offers",
    path: "/special-offers",
    meta: indexF9g60NXpcCbwPj1K_I578p7HWjHZoFikgBT7vL3xpNAMeta || {},
    component: () => import("/app/pages/special-offers/index.vue")
  },
  {
    name: "special-offers-slug",
    path: "/special-offers/:slug()",
    component: () => import("/app/pages/special-offers/[slug].vue")
  },
  {
    name: "special-offers-archive",
    path: "/special-offers/archive",
    meta: archiveXwhoTSCRF8jJe8XuTVzogvq8gvbBnlyw0U9LS_45LsJl8Meta || {},
    component: () => import("/app/pages/special-offers/archive.vue")
  },
  {
    name: "catalog-slug",
    path: "/catalog/:slug(.*)*",
    component: () => import("/app/pages/catalog/[...slug]/index.vue")
  },
  {
    name: "orders-confirmation-orderId",
    path: "/orders/confirmation/:orderId()",
    component: () => import("/app/pages/orders/confirmation/[orderId].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/news/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/articles/:pathMatch(.*)",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]